var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-page",
    {
      staticClass: "modal-page",
      attrs: {
        heading: _vm.hasSubmitted
          ? "Thank you for registering!"
          : "Sign up for a new account"
      }
    },
    [
      _vm.hasSubmitted
        ? [
            _c("p", [
              _vm._v(
                "Once your account is approved by Vivid Seats you will be able to start transacting on the site."
              )
            ])
          ]
        : [
            _c(
              "form",
              {
                staticClass: "form grid",
                attrs: { novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "grid__row" }, [
                  _c("div", { staticClass: "grid__col grid__col--100" }, [
                    _c(
                      "label",
                      {
                        staticClass: "reader-only",
                        attrs: { for: "RegisterFirstName" }
                      },
                      [_vm._v("First Name")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.firstName,
                          expression: "firstName",
                          modifiers: { trim: true }
                        },
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required",
                          expression: "'required'",
                          modifiers: { disable: true }
                        }
                      ],
                      class: {
                        "input--invalid": _vm.errors.has("RegisterFirstName")
                      },
                      attrs: {
                        autocomplete: "given-name",
                        id: "RegisterFirstName",
                        name: "RegisterFirstName",
                        placeholder: "First Name",
                        type: "text"
                      },
                      domProps: { value: _vm.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.firstName = $event.target.value.trim()
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("RegisterFirstName")
                      ? _c("span", { staticClass: "error-message" }, [
                          _vm._v(_vm._s(_vm.errors.first("RegisterFirstName")))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "grid__row" }, [
                  _c("div", { staticClass: "grid__col grid__col--100" }, [
                    _c(
                      "label",
                      {
                        staticClass: "reader-only",
                        attrs: { for: "RegisterLastName" }
                      },
                      [_vm._v("Last Name")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.lastName,
                          expression: "lastName",
                          modifiers: { trim: true }
                        },
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required",
                          expression: "'required'",
                          modifiers: { disable: true }
                        }
                      ],
                      class: {
                        "input--invalid": _vm.errors.has("RegisterLastName")
                      },
                      attrs: {
                        autocomplete: "family-name",
                        id: "RegisterLastName",
                        name: "RegisterLastName",
                        placeholder: "Last Name",
                        type: "text"
                      },
                      domProps: { value: _vm.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.lastName = $event.target.value.trim()
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("RegisterLastName")
                      ? _c("span", { staticClass: "error-message" }, [
                          _vm._v(_vm._s(_vm.errors.first("RegisterLastName")))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "grid__row" }, [
                  _c("div", { staticClass: "grid__col grid__col--100" }, [
                    _c(
                      "label",
                      {
                        staticClass: "reader-only",
                        attrs: { for: "RegisterEmail" }
                      },
                      [_vm._v("Email Address")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.email,
                          expression: "email",
                          modifiers: { trim: true }
                        },
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required|email|whitelisted-domain",
                          expression: "'required|email|whitelisted-domain'",
                          modifiers: { disable: true }
                        }
                      ],
                      class: {
                        "input--invalid": _vm.errors.has("RegisterEmail")
                      },
                      attrs: {
                        autocomplete: "email",
                        id: "RegisterEmail",
                        name: "RegisterEmail",
                        placeholder: "Email Address",
                        type: "email"
                      },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value.trim()
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("RegisterEmail")
                      ? _c("span", { staticClass: "error-message" }, [
                          _vm._v(_vm._s(_vm.errors.first("RegisterEmail")))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "grid__row" }, [
                  _c("div", { staticClass: "grid__col grid__col--100" }, [
                    _c(
                      "label",
                      {
                        staticClass: "reader-only",
                        attrs: { for: "RegisterPassword" }
                      },
                      [_vm._v("Password (min 8 characters)")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.password,
                          expression: "password",
                          modifiers: { trim: true }
                        },
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required|min:8",
                          expression: "'required|min:8'",
                          modifiers: { disable: true }
                        }
                      ],
                      ref: "RegisterPassword",
                      class: {
                        "input--invalid": _vm.errors.has("RegisterPassword")
                      },
                      attrs: {
                        autocomplete: "new-password",
                        id: "RegisterPassword",
                        name: "RegisterPassword",
                        placeholder: "Password",
                        type: "password"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value.trim()
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("RegisterPassword")
                      ? _c("span", { staticClass: "error-message" }, [
                          _vm._v(_vm._s(_vm.errors.first("RegisterPassword")))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "grid__row" }, [
                  _c("div", { staticClass: "grid__col grid__col--100" }, [
                    _c(
                      "label",
                      {
                        staticClass: "reader-only",
                        attrs: { for: "RegisterConfirmPassword" }
                      },
                      [_vm._v("Confirm Password")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required|confirmed:RegisterPassword",
                          expression: "'required|confirmed:RegisterPassword'",
                          modifiers: { disable: true }
                        }
                      ],
                      class: {
                        "input--invalid": _vm.errors.has(
                          "RegisterConfirmPassword"
                        )
                      },
                      attrs: {
                        autocomplete: "new-password",
                        id: "RegisterConfirmPassword",
                        name: "RegisterConfirmPassword",
                        placeholder: "Confirm Password",
                        type: "password"
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("RegisterConfirmPassword")
                      ? _c("span", { staticClass: "error-message" }, [
                          _vm._v(
                            _vm._s(_vm.errors.first("RegisterConfirmPassword"))
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "grid__row" }, [
                  _c("div", { staticClass: "grid__col grid__col--100" }, [
                    _c(
                      "button",
                      {
                        staticClass: "submit",
                        attrs: { type: "submit", disabled: _vm.isSaving }
                      },
                      [_vm._v("Sign Up")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "modal-page__login" },
              [
                _vm._v("Already have an account? "),
                _c("router-link", { attrs: { to: { name: "login" } } }, [
                  _vm._v("Sign In")
                ])
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }